import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import AdminHeader from '../../../common_components/admin_module_header';
import Footerlogin from '../../../common_components/Footerlogin';
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { selectApplication_action } from "../../../actions/exhibitor_module_actions/select_application_action/select_application_action"
import { toastError, toastSuccess, link_BASE_URL } from "../../../utils/constants"
import ApplicationHeader from "../../../common_components/application_header";


class SelectApplication extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            selectApplicationList: [],
        }
        this.handleView = this.handleView.bind(this)
        this.getSelectApplication = this.getSelectApplication.bind(this)
        this.onAddApplication = this.onAddApplication.bind(this)
    }


    componentDidMount() {
        this.getSelectApplication()
    }

    // get SelectApplication
    getSelectApplication() {
        this.setState({ isLoading: true })

        console.log("ooooooooooooooooooooooooooooooooooooo", sessionStorage.getItem("RoleIDSS",))
        this.props.selectApplication_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("get APplication-----------", data.data)
                    if (data.data.length == 1) {
                        // sessionStorage.setItem("ApplicationDataSS", JSON.stringify(data.data[0]))
                        // sessionStorage.setItem('ServiceIDSS', data.data[0]['ServiceID'])
                        // sessionStorage.setItem('ExhRegistrationIDSS', data.data[0]['ExhRegistrationID'])
                        // sessionStorage.setItem('ExhRegistrationNo', data.data[0]['ExhRegistrationNo'])
                        // sessionStorage.setItem('CurrencyID', data.data[0]['CurrencyID'])
                        // this.props.navigate('/exhibitor_dashboard')
                    }
                    if (data.data.length > 0) {
                        sessionStorage.setItem('isPaidByAgentRegistration', data.data[0]['ISPaidByAgentRegistration'] ? true : false)
                        sessionStorage.setItem('isAgentRegistered', data.data[0].AgentID != null && data.data[0].AgentID != '' ? true : false)
                    }
                    this.setState({ selectApplicationList: data.data, isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    handleView(id, data) {
        if (data.StatusID == 1) {
            var url = `${link_BASE_URL}registration/${data.UUID}`;
            const win = window.open(url, '_blank', 'noopener,noreferrer');
            if (win != null) {
                win.focus();
            }
        } else if (data.StatusID == 2) {
            var url = `${link_BASE_URL}primary_chapter/${data.UUID}`;
            const win = window.open(url, '_blank', 'noopener,noreferrer');
            if (win != null) {
                win.focus();
            }
        }
        else if (data.StatusID == 3) {
            var url = `${link_BASE_URL}primary_chapter/${data.UUID}`;
            const win = window.open(url, '_blank', 'noopener,noreferrer');
            if (win != null) {
                win.focus();
            }
        } else {
            if (JSON.parse(sessionStorage.getItem('loginDataSS')) != null) {
                var loginDataSS = JSON.parse(sessionStorage.getItem('loginDataSS'))
                loginDataSS.CountryID = data.CountryID
                loginDataSS.CountryName = data.CountryName
                loginDataSS.City = data.City
                loginDataSS.MobileNo = data.MobileNo
                sessionStorage.setItem('loginDataSS', JSON.stringify(loginDataSS))
            }
            sessionStorage.setItem("ApplicationDataSS", JSON.stringify(data))
            sessionStorage.setItem('ServiceIDSS', data.ServiceID)
            sessionStorage.setItem('countryId', data.CountryID)
            sessionStorage.setItem('CountryName', data.CountryName)
            sessionStorage.setItem('ExhRegistrationIDSS', data.ExhRegistrationID)
            sessionStorage.setItem('ExhRegistrationNo', data.ExhRegistrationNo)
            sessionStorage.setItem('isPaidByAgentRegistration', data.ISPaidByAgentRegistration ? 1 : 0)
            this.props.navigate('/exhibitor_dashboard', { state: { serviceId: id } })
        }
    }

    onAddApplication() {
        var url = `${link_BASE_URL}registration/#&${sessionStorage.getItem('userEmailSS').trim()}#&${sessionStorage.getItem('exhibitionCode')}`;
        const win = window.open(url, '_blank', 'noopener,noreferrer');
        if (win != null) {
            win.focus();
        }
    }

    // One application: details rows with icons, status pill and the action button.
    // statusText / buttonText / onClick come from the same rules as before.
    renderApplicationCard(data, statusText, buttonText, onClick) {
        const statusClass = statusText == 'Applied' ? 'sa-pill-ok' : statusText == 'Waitlist' ? 'sa-pill-wait' : 'sa-pill-pending'
        return (
            <div className="col-xl-4 col-lg-6 col-12 mb-4" key={data.ExhRegistrationNo}>
                <div className="sa-card">
                    <div className="sa-card-head">
                        <span className="sa-head-icon"><i className="fa fa-file-text-o"></i></span>
                        <h5 className="mb-0">Application Details</h5>
                    </div>
                    <div className="sa-rows">
                        <div className="sa-row">
                            <span className="sa-row-icon"><i className="fa fa-hashtag"></i></span>
                            <div><div className="sa-label">Application Reference Number</div><div className="sa-value">{data.ExhRegistrationNo}</div></div>
                        </div>
                        <div className="sa-row">
                            <span className="sa-row-icon"><i className="fa fa-arrows-alt"></i></span>
                            <div><div className="sa-label">Booth Area (m2)</div><div className="sa-value">{data.StallArea}-{data.StallTypeName}</div></div>
                        </div>
                        <div className="sa-row">
                            <span className="sa-row-icon"><i className="fa fa-th-large"></i></span>
                            <div><div className="sa-label">Main Category</div><div className="sa-value">{data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}</div></div>
                        </div>
                        <div className="sa-row">
                            <span className="sa-row-icon"><i className="fa fa-check-circle-o"></i></span>
                            <div><div className="sa-label">Booking Status</div><span className={`sa-pill ${statusClass}`}>{statusText == 'Applied' && <i className="fa fa-check me-1"></i>}{statusText}</span></div>
                        </div>
                    </div>
                    <div className="sa-actions">
                        <button type="button" className="btn sa-btn" onClick={onClick} disabled={!onClick}>
                            <span><i className={`fa ${statusText == 'Waitlist' ? 'fa-clock-o' : 'fa-eye'} me-2`}></i>{buttonText}</span>
                            <i className="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    // "New Application" card: message + button to start another application
    renderNewApplicationCard(message) {
        return (
            <div className="col-xl-4 col-lg-6 col-12 mb-4">
                <div className="sa-card">
                    <div className="sa-card-head sa-card-head-light">
                        <span className="sa-head-icon"><i className="fa fa-file-o"></i><i className="fa fa-plus-circle sa-plus"></i></span>
                        <h5 className="mb-0">New Application</h5>
                    </div>
                    <div className="sa-new-body">
                        <div className="sa-illustration">
                            <i className="fa fa-file-text-o"></i>
                            <span className="sa-illustration-plus"><i className="fa fa-plus"></i></span>
                        </div>
                        <p className="mb-0">{message}<br />Please click the button below.</p>
                    </div>
                    <div className="sa-actions">
                        <button type="button" className="btn sa-btn" onClick={() => this.onAddApplication()}>
                            <span><i className="fa fa-plus-circle me-2"></i>New Application</span>
                            <i className="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { isLoading, selectApplicationList } = this.state
        console.log(JSON.parse(sessionStorage.getItem('loginDataSS')).CountryID)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ApplicationHeader />
                {/* <AdminHeader /> */}
                <div className="row m-0"><div className="breadcrumb-scroll-fixed px-2 sa-bar"><h6 className="mb-0 p-2 text-white px-2">Choose your Application</h6></div></div>
                {/* <div className="container-fluid">
                    <div className="row">
                        <div className="breadcrumb-scroll-fixed">  
                            <h6 className="mb-0 p-2 text-white">Choose your Application</h6>
                        </div>
                    </div>
                </div> */}
                <div className="container-fluid exb-top-space-2 p-0 px-3 sa-page" style={{ marginBottom: '10rem' }}>
                    <div className="row">
                        {selectApplicationList.length > 0 && selectApplicationList.map(data => {
                            const statusText = data.StatusID < 4 ? 'Incomplete' : 'Applied'
                            const buttonText = data.StatusID < 4 ? 'Resume Application' : 'View Application'
                            const onView = () => this.handleView(data.ServiceID, data)
                            if (data.StatusID == 5) {
                                return this.renderApplicationCard(data, 'Waitlist', 'Application in Waitlist', null)
                            }
                            if (data.StatusID < 4 && sessionStorage.getItem("isAgentRegistered") == 'true') {
                                // Agent-registered incomplete applications: only when not paid by the agent, or with indirect access
                                if (sessionStorage.getItem("isPaidByAgentRegistration") == 'false' || sessionStorage.getItem("isIndirectAccess") == 'true') {
                                    return this.renderApplicationCard(data, statusText, buttonText, onView)
                                }
                                return null
                            }
                            return this.renderApplicationCard(data, statusText, buttonText, onView)
                        })}
                        {selectApplicationList.length > 0
                            ? (sessionStorage.getItem("isAgentRegistered") == 'true' ? null : this.renderNewApplicationCard('If you would like to submit another application for this exhibition,'))
                            : this.renderNewApplicationCard('It seems that you dont have any application submitted for this Exhibition Yet.')}
                    </div>
                    <div style={{ height: '40px', width: '100%', clear: 'both' }}></div>
                    {/* <div className="row p-3">
                        <a href="#">
                            <button
                                type="button"
                                className="btn btn-outline-light text-dark mt-3"
                                style={{
                                    background: "#f2e9e5",
                                    width: "24%",
                                    borderRadius: 0,
                                    border: "1px solid #eb7520",
                                    marginLeft: "-13px"
                                }}
                            >
                                Additional Stall Registration
                            </button>
                        </a>
                    </div> */}
                </div >
                <Footerlogin />
            </>

        )
    }
}



export default withRouter(connect(null, { selectApplication_action })(SelectApplication));
